import Vue from "vue";
import Vuex from "vuex";
import { IUserState } from "./modules/user";
import { INotificationState } from "./modules/notification";
import { IApplicationState } from "./modules/application";
import { IHomeState } from "./modules/home";
Vue.use(Vuex);
export interface IRootState {
  user: IUserState;
  notification: INotificationState;
  application: IApplicationState;
  home: IHomeState;
}
export default new Vuex.Store<IRootState>({});
